import { render } from "./IndexNavbar.vue?vue&type=template&id=31a06ab0"
import script from "./IndexNavbar.vue?vue&type=script&lang=js"
export * from "./IndexNavbar.vue?vue&type=script&lang=js"

import "./IndexNavbar.vue?vue&type=style&index=0&id=31a06ab0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__